import { Calendar, Clock, MapPin, Users, Lock } from "lucide-react";
import Reveal from "@/components/site/Reveal";

const infos = [
  {
    icon: Calendar,
    label: "Format",
    value: "Journée complète ou week-end de deux jours",
  },
  {
    icon: Clock,
    label: "Rythme",
    value: "Plusieurs week-ends par an",
  },
  {
    icon: MapPin,
    label: "Lieu",
    value: "Valromey sur Séran (Ain · 01)",
  },
  {
    icon: Users,
    label: "Groupe",
    value: "Nombre de participants limité",
  },
  {
    icon: Lock,
    label: "Cadre",
    value: "Confidentiel et respectueux",
  },
];

export default function CPracticalInfo() {
  return (
    <section
      data-testid="c-practical"
      className="py-24 md:py-32 bg-[#F3EEF4]"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto">
          <Reveal>
            <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
              — Pratique
            </span>
            <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 leading-[1.05]">
              Informations pratiques
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {infos.map(({ icon: Icon, label, value }, i) => (
            <Reveal key={label} delay={i * 0.06}>
              <div
                data-testid={`c-practical-item-${i}`}
                className="h-full p-6 bg-white rounded-3xl border border-[#DDD7E2]"
              >
                <Icon className="w-5 h-5 text-[#C98FA3]" />
                <p className="text-xs uppercase tracking-[0.18em] text-[#5F6170] font-medium mt-4">
                  {label}
                </p>
                <p className="mt-2 text-base text-[#1E1E2A] leading-snug">
                  {value}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.25}>
          <div className="mt-10 grid md:grid-cols-2 gap-4">
            <div
              data-testid="c-tarif-participant"
              className="p-8 rounded-3xl bg-white border border-[#DDD7E2] flex items-center justify-between"
            >
              <div>
                <p className="text-xs uppercase tracking-[0.18em] text-[#5F6170] font-medium">
                  Tarif participant
                </p>
                <p className="font-serif-display text-3xl text-[#3A2E6E] mt-2">
                  110 €
                </p>
                <p className="text-xs text-[#5F6170] mt-1 italic">
                  Tarif actuel · sujet à modification
                </p>
              </div>
              <span className="text-sm text-[#C98FA3] uppercase tracking-[0.2em] font-medium">
                Avec problématique
              </span>
            </div>
            <div
              data-testid="c-tarif-representant"
              className="p-8 rounded-3xl bg-white border border-[#DDD7E2] flex items-center justify-between"
            >
              <div>
                <p className="text-xs uppercase tracking-[0.18em] text-[#5F6170] font-medium">
                  Tarif représentant
                </p>
                <p className="font-serif-display text-3xl text-[#3A2E6E] mt-2">
                  30 €
                </p>
                <p className="text-xs text-[#5F6170] mt-1 italic">
                  Tarif actuel · sujet à modification
                </p>
              </div>
              <span className="text-sm text-[#C98FA3] uppercase tracking-[0.2em] font-medium">
                Représentant
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
